import React, { useContext } from 'react';
import { CartContext } from '../Context/CartContext';
import { Link, useNavigate } from 'react-router-dom';
import { ChevronRight, Trash2 } from 'lucide-react';

function Orders() {
    const { cart, removeFromCart } = useContext(CartContext);
    const navigate = useNavigate();

    const handleRemove = (itemId) => {
        removeFromCart(itemId);
    };

    const sendOrder = () => {
        const businessWhatsAppNumber = '+972559986085';
        const businessEmail = 'bwdwtz417@gmail.com';

        const orderDetails = cart.map((item) => `
תיאור: ${item.title}
מידות: ${item.size}
צבע: ${item.color.name}
סוג עץ: ${item.woodType}
    `).join('\n\n');

        const orderSummary = `כמות הפריטים לפרויקט: ${cart.length}`;
        const message = `שלום, אשמח לקבל הצעת מחיר עבור הפריטים הבאים:\n\n${orderDetails}\n\n${orderSummary}`;

        if (window.matchMedia("(max-width: 767px)").matches) {
            window.open(`https://wa.me/${businessWhatsAppNumber}?text=${encodeURIComponent(message)}`, '_blank');
        } else {
            window.open(`https://mail.google.com/mail/u/0/?view=cm&fs=1&to=${businessEmail}&su=בקשה להצעת מחיר - פרויקט עץ&body=${encodeURIComponent(message)}`, '_blank');
        }
    };

    const OrderItem = ({ item, onRemove }) => (
        <div className="bg-surface rounded-2xl overflow-hidden transition-all duration-300 shadow-soft hover:shadow-hover border border-secondary/50 flex flex-col">
            <div className="relative aspect-[4/3] bg-secondary overflow-hidden group">
                <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-500" />
            </div>

            <div className="p-6 flex flex-col flex-grow bg-surface relative z-10">
                <h2 className="text-xl font-medium text-text-primary mb-5 border-r-4 border-accent pr-3">
                    {item.title}
                </h2>

                <div className="space-y-3 flex-grow mb-6">
                    <div className="flex items-start justify-between text-sm">
                        <span className="text-text-secondary font-medium">מידות:</span>
                        <span className="text-text-primary text-left max-w-[60%] bg-background px-3 py-1 rounded-md">{item.size}</span>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                        <span className="text-text-secondary font-medium">גוון/צבע:</span>
                        <div className="flex items-center gap-2 bg-background px-3 py-1 rounded-md">
                            <span className="text-text-primary">{item.color?.name || 'ללא'}</span>
                            <span className="w-4 h-4 rounded-full border border-secondary-dark shadow-sm block" style={{ backgroundColor: item.color?.code || 'transparent' }} />
                        </div>
                    </div>
                    <div className="flex items-center justify-between text-sm">
                        <span className="text-text-secondary font-medium">סוג עץ:</span>
                        <span className="text-text-primary bg-background px-3 py-1 rounded-md">{item.woodType}</span>
                    </div>
                </div>

                <button
                    className="flex items-center justify-center gap-2 w-full py-3 mt-auto text-text-secondary hover:text-red-600 border border-secondary-dark rounded-xl hover:bg-red-50 hover:border-red-200 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                    onClick={() => handleRemove(item.id)}
                    aria-label={`הסר ${item.title}`}
                >
                    <Trash2 className="w-4 h-4" />
                    <span className="text-sm font-medium">הסר פריט</span>
                </button>
            </div>
        </div>
    );

    return (
        <div className="min-h-screen bg-background pt-10 pb-16 sm:pt-10 sm:pb-24 px-4 sm:px-6 lg:px-8" dir="rtl">
            <div className="max-w-7xl mx-auto">

                {/* ניווט וכותרת */}
                <div className="flex flex-col gap-4 mb-12">
                    <button
                        onClick={() => navigate(-1)}
                        className="flex items-center gap-2 text-text-secondary hover:text-primary transition-colors duration-300 group w-fit text-sm font-medium"
                    >
                        <ChevronRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
                        <span>חזרה להמשך בחירה</span>
                    </button>
                    <h1 className="text-4xl sm:text-5xl font-medium text-text-primary border-r-4 border-accent pr-4 py-1">
                        סל הפרויקטים שלי
                    </h1>
                </div>

                {cart.length === 0 ? (
                    <div className="text-center py-20 bg-surface rounded-2xl border border-secondary/50 shadow-soft">
                        <p className="text-2xl font-medium text-text-primary mb-4">הסל שלך ריק כרגע</p>
                        <p className="text-text-secondary mb-8 font-light">
                            זה הזמן לחזור לקטלוג, לאסוף השראות ולהתחיל לתכנן את הפרויקט הבא שלך.
                        </p>
                        <Link
                            to="/"
                            className="inline-block px-10 py-4 bg-primary text-white text-lg font-medium rounded-xl hover:bg-primary-light transition-all duration-300 shadow-soft hover:shadow-hover"
                        >
                            חזרה לקטלוג המוצרים
                        </Link>
                    </div>
                ) : (
                    <>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8 mb-16">
                            {cart.map((item, index) => (
                                <OrderItem key={`${item.id}-${index}`} item={item} onRemove={handleRemove} />
                            ))}
                        </div>

                        {/* אזור סיום וסיכום */}
                        <div className="max-w-2xl mx-auto">
                            <div className="bg-surface rounded-2xl border border-secondary/50 p-8 shadow-soft text-center">
                                <div className="flex items-center justify-between border-b border-secondary pb-6 mb-6">
                                    <h2 className="text-2xl font-medium text-text-primary">סיכום ביניים</h2>
                                    <div className="flex items-center gap-2 bg-background px-4 py-2 rounded-lg border border-secondary-dark/30">
                                        <span className="text-text-secondary font-medium">סה"כ פריטים:</span>
                                        <span className="text-xl font-bold text-accent">{cart.length}</span>
                                    </div>
                                </div>

                                <p className="text-base text-text-secondary mb-8 leading-relaxed font-light">
                                    בלחיצה על הכפתור, תעברו להתכתבות ישירה איתנו (בוואטסאפ או במייל).
                                    אנו נעבור על המפרט שבחרתם ונחזור אליכם עם הצעת מחיר מסודרת וייעוץ מקצועי להמשך הפרויקט.
                                </p>

                                <button
                                    onClick={sendOrder}
                                    className="w-full sm:w-auto px-12 py-4 bg-primary text-white text-lg font-medium rounded-xl hover:bg-primary-light transition-all duration-300 shadow-soft hover:shadow-hover focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                                >
                                    בקשה להצעת מחיר
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
}

export default Orders;